import { OGILayerIds, OGIPointInfrastructureIds } from '../types';
import { MethaneLayerIds } from '../types/MapLayers';

/**
 * Temporary workaround to only show pick info for one layer. Higher priority layers appear first
 * in this array. If a layer id does not appear in this array, it is still picked but prioritized last.
 */
export const pickInfoPriority = [
    MethaneLayerIds.targets,
    OGILayerIds.pointInfrastructure,
    `${OGILayerIds.tileInfrastructure}-points`,
    MethaneLayerIds.plumeEmissionRate,
    OGILayerIds.tileInfrastructure,
    ...Object.values(OGIPointInfrastructureIds),
    OGILayerIds.pipelines,
    OGILayerIds.basins,
    MethaneLayerIds.areaEmissionRaster
];
